import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  href: "/",
  class: "a-title text-over"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "menu-box" }

import { ref, computed, watch } from 'vue'
	import { getMenu } from "@/request/api/auth"
	import { useModuleMapState } from '@/config/useMapState'
	import MenuTree from "@/components/com/MenuTree"
	
	
export default /*@__PURE__*/_defineComponent({
  __name: 'LeftMenu',
  setup(__props) {

	const showEmpty = ref(false)
	const menuLoading = ref(false)
	const menuData = ref([])
	
	const defaultOpeneds = computed(() => {
		if(menuData.value.length){
			return menuData.value.map((v, i) => {
				return v.path
			})
		}else{
			return []
		}
	})
	const getLeftMenu = async () => {
		try {
			menuLoading.value = true
			let { code, data } = await getMenu()
			menuLoading.value = false
			if(code == 200){
				data = data.map((v) => {
					v.icon = v.icon.replace(/ fa-/, ' icon-')
					if(v.children && v.children.length){
						v.children = v.children.map((item:any) => {
							item.icon = item.icon.replace(/ fa-/, ' icon-')
							return item
						})
					}
					return v
				})
				menuData.value = data
				if (menuData.value.length === 0) showEmpty.value = true
				else showEmpty.value = false
			}else{
				showEmpty.value = true
			}
		} catch (error) {
		  showEmpty.value = true
		  setTimeout(() => { menuLoading.value = false }, 0)
		  console.log('getMenu fail', error)
		}
	}
	const init = () => {
		getLeftMenu()
	}
	const { token, platformInfo, isCollapse } = useModuleMapState('publicOptions', ['token', 'platformInfo', 'isCollapse'])
	if(token.value) init()
	watch(token, (val) => {
		if(val) init()
	})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_menu, {
    class: "left-menu",
    "element-loading-text": "菜单加载中...",
    "element-loading-spinner": "el-icon-loading",
    "element-loading-background": "rgba(0, 0, 0, 0.4)",
    "default-active": _ctx.$route.path,
    collapse: _unref(isCollapse),
    "default-openeds": defaultOpeneds.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("a", _hoisted_1, [
        _createElementVNode("span", {
          slot: "title",
          class: "title",
          title: _unref(platformInfo).innerPageName
        }, _toDisplayString(_unref(platformInfo).innerPageName), 9, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(MenuTree), { menuData: menuData.value }, null, 8, ["menuData"])
      ]),
      (showEmpty.value && !_unref(isCollapse))
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            class: "empty"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: getLeftMenu
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("重 试")
                ])),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["default-active", "collapse", "default-openeds"])), [
    [_directive_loading, menuLoading.value]
  ])
}
}

})